import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalAddTrailService {
  private _elementSelected$ = new BehaviorSubject<any>(undefined);
  private _selectedElements$ = new BehaviorSubject<any[]>([]);

  constructor() {}

  public get elementSelected$(): Observable<any> {
    return this._elementSelected$.asObservable();
  }

  public set elementSelected$(element: any) {
    this._elementSelected$.next(element);
  }

  public get selectedElements$(): Observable<any> {
    return this._selectedElements$.asObservable();
  }

  public isCourseSelected = (course: any): boolean => {
    const selectedElements = this._selectedElements$.value || [];
    if (course.subdivisoes?.length) {
      return selectedElements.some(() => course.subdivisoes.some(this.isSubdivisionSelected));
    }
    if (course.trilhas?.length) {
      return selectedElements.some(() => course.trilhas.some(this.isTrailSelected));
    }
  };

  public isSubdivisionSelected = (subdivision: any): boolean => {
    const selectedElements = this._selectedElements$.value || [];
    if (subdivision.subdivisoes?.length) {
      return selectedElements.some(() => subdivision.subdivisoes.some(this.isSubdivisionSelected));
    }
    if (subdivision.trilhas?.length) {
      return selectedElements.some(() => subdivision.trilhas.some(this.isTrailSelected));
    }
  };

  public isTrailSelected = (trail: any): boolean => {
    const selectedElements = this._selectedElements$.value || [];
    return selectedElements.some(() => trail.sessoes.some((session) => session.elementos.some(this.isElementSelected)));
  };

  public isElementSelected = (element: any): boolean => {
    const selectedElements = this._selectedElements$.value || [];
    return selectedElements.some((el) => el.id === element.id);
  };

  public selectSubdivision(subdivision: any, checked: boolean) {
    if (subdivision.subdivisoes?.length) {
      subdivision.subdivisoes.forEach((sub) => this.selectSubdivision(sub, checked));
    }

    if (subdivision.trilhas?.length) {
      subdivision.trilhas.forEach((trail) => this.selectTrail(trail, checked));
    }
  }

  public selectTrail(trail: any, checked: boolean) {
    trail.sessoes.forEach((session) => session.elementos.forEach((element) => this.selectElement(element, checked)));
  }

  public selectElement(element: any, checked: boolean) {
    const selectedElements = [...(this._selectedElements$.value || [])];

    if (checked) {
      if (!selectedElements.find((el) => el.id === element.id)) {
        selectedElements.push(element);
      }
    } else {
      const index = selectedElements.findIndex((el) => el.id === element.id);
      if (index !== -1) {
        selectedElements.splice(index, 1);
      }
    }

    this._selectedElements$.next(selectedElements);
  }

  public clearSelectedElements() {
    this._selectedElements$.next([]);
  }

  public forceSelectedElements(elements: any[]) {
    this._selectedElements$.next(elements);
  }
}
